import ApiService from '../data/services/ApiService'

export const PROGRAMACION_INTERVALOS = [
    { value: 'semanal', label: 'Semanal' },
    { value: 'quincenal', label: 'Quincenal' },
    { value: 'mensual', label: 'Mensual' },
    { value: 'bimestral', label: 'Bimestral' },
    { value: 'trimestral', label: 'Trimestral' },
    { value: 'anual', label: 'Anual' }
]

export const getDatetimeLocalValue = (value) => {
    if (!value) {
        return ''
    }

    const date = new Date(value)
    const timezoneOffset = date.getTimezoneOffset() * 60000

    return new Date(date.getTime() - timezoneOffset).toISOString().slice(0, 16)
}

export const getMinScheduledDatetime = () => {
    return getDatetimeLocalValue(new Date())
}

export const submitProgramacionFactura = async (facturaId, payload) => {
    return ApiService.programarFactura(facturaId, payload)
}

export const cancelarProgramacionFactura = async (facturaId) => {
    return ApiService.desprogramarFactura(facturaId)
}

export const reintentarFacturaProgramada = async (facturaId) => {
    return ApiService.reintentarFactura(facturaId)
}

export const getDashboardFacturasProgramadas = (facturas = []) => {
    const programadas = facturas
        .filter((factura) => factura.status === 'programada')
        .slice(0, 3)

    const fallidas = facturas
        .filter((factura) => factura.status === 'fallida')
        .slice(0, 3)

    return {
        programadas,
        fallidas
    }
}

export const getProgramacionInicial = (factura) => {
    return {
        scheduledFor: factura?.schedule?.scheduledFor || new Date(),
        isRecurring: Boolean(factura?.schedule?.isRecurring),
        interval: factura?.schedule?.interval || 'mensual'
    }
}
